module.exports = __webpack_public_path__ + "img/color.703d8dd2.png";